import React from 'react';
import LeaderboardBackToOGV2 from '../back-to-og-v2/LeaderboardBackToOGV2';
import { fetchBackToOgReplayData } from './backToOgReplayData';

export default function LeaderboardBackToOGV3() {
    return <LeaderboardBackToOGV2
        fetchLeaderboardData={fetchBackToOgReplayData}
        defaultLeaderboardId='Back_To_OG'
        showLoadState
    />;
}
